import { Set } from "immutable";
import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import { amber } from "@material-ui/core/colors";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Button, Typography } from "@material-ui/core";

import { HeaderBase } from "altus-ui-components";

import {
  getGroupsFromState,
  getViewGroupsFromState,
  getVisibleCardsFromState,
  getCardSearchResultsFromState,
  getGroupSearchResultsFromState,
} from "features/planner/planner.selectors";

import { clearSearch } from "features/planner/planner.actions";

class SearchResultTopPanel extends PureComponent {
  getSearchDiff = (searchResults, visibleEntities) => {
    const searchResultIds = Set(searchResults.map(entity => entity.get("id")));
    const visibleEntitiesIds = Set(
      visibleEntities.map(entity => entity.get("id")),
    );

    return searchResultIds.subtract(visibleEntitiesIds).size;
  };

  clearSearch = () => {
    const { viewId, dispatchClearSearch } = this.props;

    dispatchClearSearch(viewId);
  };

  render() {
    const {
      groups,
      classes,
      viewGroups,
      visibleCards,
      cardSearchResults,
      groupSearchResults,
    } = this.props;

    const notVisibleCards = this.getSearchDiff(cardSearchResults, visibleCards);

    const hitCount = groupSearchResults.size + cardSearchResults.size;

    return (
      <HeaderBase
        classes={{
          root: classes.root,
        }}
      >
        <Grid container wrap="nowrap" alignItems="center">
          <Grid item xs>
            <Typography
              className={classes.title}
            >{`Found: ${hitCount}`}</Typography>
          </Grid>
          <Grid item xs container justifyContent="center">
            <Grid item>
              <Typography className={classes.title}>
                {`Not visible: ${groups.size -
                  viewGroups.size} Location(s), ${notVisibleCards} Card(s)`}
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs container justifyContent="flex-end">
            <Button
              variant="outlined"
              onClick={this.clearSearch}
              className={classes.clearButton}
            >
              Clear
            </Button>
          </Grid>
        </Grid>
      </HeaderBase>
    );
  }
}

const styles = theme => ({
  root: {
    top: 0,
    zIndex: 2,
    position: "sticky",
    background: amber[400],
    color: theme.palette.getContrastText(amber[400]),
  },
  clearButton: {
    fontWeight: theme.typography.fontWeightBold,
    textTransform: "none",
  },
  title: {
    fontSize: "1rem",
    fontWeight: theme.typography.fontWeightBold,
  },
});

export default compose(
  connect(
    state => ({
      groups: getGroupsFromState(state),
      viewGroups: getViewGroupsFromState(state),
      visibleCards: getVisibleCardsFromState(state),
      cardSearchResults: getCardSearchResultsFromState(state),
      groupSearchResults: getGroupSearchResultsFromState(state),
    }),
    {
      dispatchClearSearch: clearSearch,
    },
  ),
  withStyles(styles),
)(SearchResultTopPanel);
